import React from "react";

const WalletSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 33 33"
    fill="none"
  >
    <path
      d="M3.69678 10.5533L3.70303 27.0333C3.70303 28.9185 5.23123 30.4467 7.11636 30.4467H25.8897C27.7748 30.4467 29.303 28.9185 29.303 27.0333V13.38C29.303 11.8091 28.0295 10.5356 26.4586 10.5356H3.72187C3.71058 10.5356 3.70052 10.5427 3.69678 10.5533ZM3.69678 10.5533C3.69782 10.2338 22.903 2.55334 22.903 2.55334V9.75334M22.4986 20.1844L22.4764 20.2067"
      stroke="#a8a7a7ff"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default WalletSvgIcon;
